<!-- 登录时间统计 -->
<template>
  <div class="login-time-statistics">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="姓名"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.userRealName"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="账号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.loginAccount"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="身份证号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.userIdCard"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="手机号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.phone"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="所属机构"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.orgName"
                allowClear
              />
              <!-- <LenovoSelectModule
                :reset="true"
                placeholder="请输入"
                v-model="params.orgId"
                apiType="getPubOrganName"
              /> -->
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="所属部门"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <!-- <LenovoSelectModule
                :reset="true"
                placeholder="请输入"
                v-model="params.departmentName"
                apiType="getPubDeptName"
              /> -->
              <InputText
                placeholder="请输入"
                v-model="params.departmentName"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="授权应用"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.appId"
                apiType="getAllAppInfo"
                autoValue="id"
                autoLabel="appShortName"
                @change="handleChange"
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.accountStatus"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'account_status' }"
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="是否在线"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.isOnline"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'is_online' }"
              />
            </a-form-item>
          </a-col>
          <a-col class="flag" span="6" :offset="12">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts">
        <!-- <a-button type="primary" @click="handleSearch"
          ><a-icon type="plus" />新增</a-button
        > -->
        <a-button
          @click="handReport"
          v-if="role.indexOf('1HJJGR2EDVL8BC2MMJILM5HBKV001L8E') != -1"
          ><a-icon type="download" style="color: #585d68" />导出</a-button
        >
      </div>
      <TableList
        :columns="columns"
        :tableData="tableData"
        :loading="loading"
        :pageInfo="pageBean"
        @getList="changePage"
      >
        <div slot="action" slot-scope="record" class="columns-action">
          <a-button type="link" @click="handleTableRow(true, record.scope)"
            >查看登录详情</a-button
          >
        </div>
      </TableList>
    </div>
    <ViewModal
      :modalFlag="modalFlag"
      :modalData="modalData"
      @handleFlag="handleTableRow"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/logManage.js"; // 请求接口
import ViewModal from "./components/View.vue";

import "./index.less";

export default {
  components: {
    InputText,
    SelectModule,
    TableList,
    LenovoSelectModule,
    ViewModal,
  },
  computed: {
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "姓名",
          dataIndex: "userRealName",
          key: "userRealName",
          ellipsis: true,
          scopedSlots: { customRender: "userRealName" },
        },
        {
          title: "账号",
          dataIndex: "loginAccount",
          key: "loginAccount",
          ellipsis: true,
          scopedSlots: { customRender: "loginAccount" },
        },
        {
          title: "所属机构",
          dataIndex: "orgName",
          key: "orgName",
          ellipsis: true,
          scopedSlots: { customRender: "orgName" },
        },
        {
          title: "所属部门",
          dataIndex: "departmentName",
          key: "departmentName",
          // width: 130,
          ellipsis: true,
          scopedSlots: { customRender: "departmentName" },
        },
        {
          title: "授权应用",
          dataIndex: "appShortName",
          key: "appShortName",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "appShortName" },
        },
        {
          title: "状态",
          dataIndex: "accountStatusDesc",
          key: "accountStatusDesc",
          ellipsis: true,
          // width: 90,
        },
        {
          title: "最近登录时间",
          dataIndex: "loginTime",
          key: "loginTime",
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "loginTime" },
        },
        {
          title: "累计登录时长(小时)",
          dataIndex: "loginDuration",
          key: "loginDuration",
          width: 150,
          align: "right",
          ellipsis: true,
        },
        {
          title: "是否在线",
          dataIndex: "isOnlineDesc",
          key: "isOnlineDesc",
          ellipsis: true,
          width: 80,
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 130,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
    ...mapState(["role"]),
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        userRealName: "", // 用户名
        accountStatus: "", // 账号状态（0启用，1停用）-字典(account_status)
        orgName: "", // 机构id
        phone: "", // 手机号
        loginAccount: "", // 登录账号
        departmentName: "", // 部门
        userIdCard: "", // 身份证号
        isOnline: "", // 是否在线
        appId: "", // 授权app简称id
        // appShortName: "", // 授权app简称
      },
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      typeList: [], // 状态枚举
      modalFlag: false, // 弹层状态
      modalData: {}, // 表格选中数据
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 选择授权应用name
    handleChange(id, option) {
      // this.params.appShortName = option.name;
    },
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
          },
        },
      };
      API.queryUserList(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        userRealName: "", // 用户名
        accountStatus: "", // 账号状态（0启用，1停用）-字典(account_status)
        orgName: "", // 机构id
        phone: "", // 手机号
        loginAccount: "", // 登录账号
        departmentName: "", // 部门
        userIdCard: "", // 身份证号
        isOnline: "",
        appId: "", // 授权app简称id
        // appShortName: "", // 授权app简称
      };
      this.handleSearch();
    },
    // 查看详情
    handleTableRow(flag, row) {
      this.modalFlag = flag;
      this.modalData = row;
    },
    // 导出
    handReport() {
      API.exportUserList(
        {
          data: {
            params: {
              ...this.params,
            },
          },
        },
        (callback) => {}
      );
    },
  },
};
</script>
